import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { updateBusinessEntity } from 'shared/thunks/onlineBookingProfile/updateBusinessEntity';
import { updateNaturalPerson } from 'shared/thunks/onlineBookingProfile/updateNaturalPerson';

type TFormSubmitStatus = 'idle' | 'submitting' | 'success' | 'error';

export interface IHostProfileFormState {
  submitStatus: TFormSubmitStatus;
  generalError: string | null;
}

export const formInitialState: IHostProfileFormState = {
  submitStatus: 'idle',
  generalError: null,
};

const formSlice = createSlice({
  name: 'hostProfile/form',
  initialState: formInitialState,
  reducers: {
    resetFormState: () => formInitialState,
    setGeneralError(state, action: PayloadAction<string | null>) {
      state.generalError = action.payload;
    },
  },
  extraReducers(builder) {
    // Business Entity
    builder.addCase(updateBusinessEntity.pending, state => {
      state.submitStatus = 'submitting';
      state.generalError = null;
    });
    builder.addCase(updateBusinessEntity.fulfilled, state => {
      state.submitStatus = 'success';
      state.generalError = null;
    });
    builder.addCase(updateBusinessEntity.rejected, (state, action) => {
      state.submitStatus = 'error';
      if (action.payload?.type === 'api') {
        state.generalError = action.payload.data.message;
      } else if (action.payload?.type === 'unknown') {
        state.generalError = 'Неизвестная ошибка';
      }
    });

    // Natural Person
    builder.addCase(updateNaturalPerson.pending, state => {
      state.submitStatus = 'submitting';
      state.generalError = null;
    });
    builder.addCase(updateNaturalPerson.fulfilled, state => {
      state.submitStatus = 'success';
      state.generalError = null;
    });
    builder.addCase(updateNaturalPerson.rejected, (state, action) => {
      state.submitStatus = 'error';
      if (action.payload?.type === 'api') {
        state.generalError = action.payload.data.message;
      } else if (action.payload?.type === 'unknown') {
        state.generalError = 'Неизвестная ошибка';
      }
    });
  },
});

export const {
  reducer: formReducer,
  actions: { resetFormState, setGeneralError },
} = formSlice;
